/** Public n8n pricing page — the upgrade destination for non-cloud deployments. */
export const N8N_PRICING_PAGE_URL = 'https://n8n.io/pricing';
